import React from 'react'

import { ExhibitPanel } from './ExhibitPanel'
import { exhibitSlot } from './layout'
import type { FindingExhibitData } from './types'

type PairData = Extract<FindingExhibitData, { type: 'evidence-pair' }>

export function PairPanels({ data, originY = 0 }: { data: PairData; originY?: number }) {
  return <>
    <div style={exhibitSlot(data.type, 'left', originY)}><ExhibitPanel panel={data.left} testId="exhibit-left" locale={data.locale} /></div>
    <div style={{ ...exhibitSlot(data.type, 'right', originY), boxSizing: 'border-box' }}><ExhibitPanel panel={data.right} testId="exhibit-right" locale={data.locale} /></div>
  </>
}
